import { render, staticRenderFns } from "./StoreDetails.vue?vue&type=template&id=6c37e5c0&scoped=true&"
import script from "./StoreDetails.vue?vue&type=script&lang=ts&"
export * from "./StoreDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StoreDetails.vue?vue&type=style&index=0&id=6c37e5c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37e5c0",
  null
  
)

export default component.exports